import { render, staticRenderFns } from "./AddInstitutionPage.vue?vue&type=template&id=e311370a&scoped=true&"
import script from "./AddInstitutionPage.vue?vue&type=script&lang=js&"
export * from "./AddInstitutionPage.vue?vue&type=script&lang=js&"
import style0 from "./AddInstitutionPage.vue?vue&type=style&index=0&id=e311370a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e311370a",
  null
  
)

export default component.exports